<script setup lang="ts">
const config = useRuntimeConfig()
const siteUrl = String(config.public.siteUrl || 'https://369.dev').replace(/\/$/, '')

// `key: 'favicon'`: a page with an icon of its own (the public invoice page
// shows the workspace's logo) replaces this link instead of adding a second.
// unhead merges entries that share a key, so this one carries no `type`: an
// "image/x-icon" hint must never end up on a workspace's PNG logo. The .ico
// is served with its own content type.
useHead({
  link: [
    { rel: 'icon', href: '/favicon.ico', key: 'favicon' },
  ],
})

useSeoMeta({
  title: 'Workspace369',
  description: 'Client work, scheduling, proposals, estimates, invoices, and payments in one workspace.',
  ogTitle: 'Workspace369',
  ogDescription: 'Client work, scheduling, proposals, estimates, invoices, and payments in one workspace.',
  ogImage: `${siteUrl}/logo/android-chrome-512x512.png`,
  ogType: 'website',
  twitterCard: 'summary',
  twitterTitle: 'Workspace369',
  twitterDescription: 'Client work, scheduling, proposals, estimates, invoices, and payments in one workspace.',
  twitterImage: `${siteUrl}/logo/android-chrome-512x512.png`,
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="postcss">
html,
body,
#__nuxt {
  height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
